module.exports = __webpack_public_path__ + "img/download_icon_fill.c1633061.svg";